<div class="report-main">

  <!-- Buttons -->
  <div class="action-buttons noPrint">

    <button
      mat-raised-button
      color="primary"
      (click)="printPageA4()">

      Print

    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="exportExcel('dispatchwise_report')">

      Export

    </button>

    <button
      mat-raised-button
      color="warn"
      mat-dialog-close>

      Close

    </button>

  </div>

  <!-- Report Section -->
  <div id="print-section" class="table-container">

    <table class="report-table">

      

        <tr>
          <th colspan="8" class="report-title">
            Dispatch Vitaran Report
          </th>
        </tr>

        <tr>
          <th>Sr No</th>
          <th>Seller Name</th>
          <th>Taluka</th>
          <th>District</th>
          <th>Book Copies</th>
          <th>Representative</th>
          <th>Dist Mode</th>
        </tr>

      

      <tbody>

        <tr *ngFor="let item of sellerData; let i = index">

          <td>{{ i + 1 }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.taluka }}</td>
          <td>{{ item.district }}</td>
          <td>{{ item.total_book_copies }}</td>
          <td>{{ item.rep_name }}</td>
          <td>{{ item.dis_mode }}</td>

        </tr>

        <!-- NO DATA -->
        <tr *ngIf="sellerData.length === 0">
          <td colspan="7" class="no-data">
            No Data Found
          </td>
        </tr>

        <!-- TOTAL ROW -->
        <tr *ngIf="sellerData.length > 0" style="font-weight:bold; background:#f3f3f3;">

          <td colspan="4">TOTAL</td>

          <td>{{ totalCopies }}</td>

          <td></td>

          <td></td>

        </tr>

      </tbody>

    </table>

  </div>

</div>

<!-- Loader -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>